export const err_server = "Error conectando al servidor, prueba de nuevo";